export const getDefaultValues = (rtmpDetails) => ({
  RtmpLabel: rtmpDetails?.RtmpLabel || '',
  RtmpRotation: rtmpDetails?.RtmpRotation || '',
  RtmpSourceLink: rtmpDetails?.RtmpSourceLink || '',
  RtmpDestinationLinks: rtmpDetails?.RtmpDestinationLinks || '',
  RtmpDestinationKeys: rtmpDetails?.RtmpDestinationKeys || '',
});
